import type { Dataset, DatasetCreateVariables } from "./dataset.type";
import type { UseCreateOptions } from "@/hooks/queries";
import type { Int } from "@/types";

import { useCreate } from "@/hooks/queries";

export const useDatasetObservationCreate = (
  observationId: Int,
  options?: UseCreateOptions
) => {
  return useCreate<Dataset, DatasetCreateVariables>("observations.datasets", {
    ...options,
    rootId: observationId,
  });
};
